import {OperationList, OpListController} from "../operation/Operations";
import React, {useState} from "react";
import {usePopularOperationsQuery} from "./reg_api";
import {Box, Button, Toolbar} from "@mui/material";
import InitializeApp from "../../components/InitializeApp";
import Title from "../navigation/Title";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import {CurrentUserInfo} from "../../session_state";


type OpSelectWrapperProps = {
    workerID?: number|null,
    onSelect: (id: number, machineID?: number|null ) => void
}
export default ({onSelect, workerID}: OpSelectWrapperProps) => {

    const cu = useSelector<RootState, CurrentUserInfo | null>(s => s.sessionState.user);

    const defWorker = cu?.defaultWorkerID || 0;
    const {data, isFetching} = usePopularOperationsQuery({
        id: workerID || defWorker,
    });
    const [popular, setPopular] = useState(true);

    if (isFetching) {
        return <InitializeApp/>
    }
    if ((data && !data?.length) || !popular) {
        return <>
            <Title title={"Izberi operacijo - vse "}/>
            <OpListController onSelect={onSelect} selectable={true}/>
        </>
    }


    return <Box>
        <Title title={"Izberi operacijo - pogoste"}/>
        <Toolbar>
            <Button onClick={() => setPopular(false)}>Pokaži vse operacije</Button>
        </Toolbar>
        <OperationList selectable={true} list={data || []} onSelect={onSelect}/>

    </Box>
}
